export enum WorkTypeDesired {
  CasualWorkOnly = 1,
  CasualWorkWhileLookingForPermanentPosition = 2,
  PermanentPositionOnly = 3,
}
